import React, { useState } from "react";
import {
  Box,
  Typography,
  Checkbox,
  Button,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  useMediaQuery,
  Select,
  MenuItem,
} from "@mui/material";
import FAQSection from "./FAQSection";
const PricingContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  padding: theme.spacing(3),
}));

const PricingCard = styled(Box)(({ theme }) => ({
  border: "1px solid",
  borderColor: theme.palette.grey[300],
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(2),
  maxWidth: 360,
  width: "100%",
}));

const PricingCardHeader = styled(Box)(({ theme }) => ({
  borderBottom: "1px solid",
  borderColor: theme.palette.grey[300],
  paddingBottom: theme.spacing(2),
  marginBottom: theme.spacing(2),
}));

const PricingCardFeatures = styled("ul")({
  paddingLeft: 0,
  listStyleType: "none",
});

const Feature = styled("li")({
  display: "flex",
  alignItems: "center",
  marginBottom: 8,
});

const FeatureText = styled(Typography)({
  marginLeft: 8,
});

const plans = [
  {
    name: "Starter",
    price: "$0",
    features: {
      "Basic Support": true,
      "Basic Features": true,
      "Limited Usage": true,
    },
  },
  {
    name: "Pro",
    price: "$8/month",
    features: {
      "Basic Support": true,
      "Basic Features": true,
      "Unlimited Usage": true,
      "Premium Features": true,
      "Analytics": true,
      "Unlimited Booking Storage": true,
    },
  },
  {
    name: "Expert",
    price: "$12/month",
    features: {
      "Basic Support": true,
      "Basic Features": true,
      "Unlimited Usage": true,
      "Premium Features": true,
      "Analytics": true,
      "Unlimited Booking Storage": true,
      "Payments": true,
      "Advanced Analytics": true,
    },
  },
];

const PricingPage = (props) => {
  const isXsScreen = useMediaQuery("(max-width:700px)");
  const featureNames = Object.keys(plans[2].features);
  const [selectedPlan, setSelectedPlan] = useState(plans[0]);
  return (
    <>
      {" "}
      <div
        className="flex column align"
        style={{
          marginTop: "148px",
          padding: "20px",
          gap: "20px",
          paddingBottom: "70px",
        }}
      >
        <div
          style={{ width: "100%", justifyContent: "center", gap: "35px" }}
          className="flex column align"
        >
          <Typography
            variant={isXsScreen ? "h3" : "h2"}
            fontWeight={800}
            className="flex align justify"
            style={{ gap: "16px", flexWrap: "wrap", textAlign: "center" }}
          >
            Simple,{" "}
            <Typography
              variant={isXsScreen ? "h3" : "h2"}
              fontWeight={800}
              style={{
                color: "#d9bca9",
                textAlign: "center",
                fontSize: isXsScreen && "45px",
              }}
            >
              Transparent{" "}
            </Typography>{" "}
            Pricing
          </Typography>
          <Typography variant="h5" fontWeight={600}>
            {" "}
            Choose a plan that's right for you. Upgrade, downgrade, or cancel
            any time.
          </Typography>
        </div>
        <PricingContainer
          style={{
            height: "100vh",
            width: "100%",
            maxWidth: "1300px",
            gap: "50px",
          }}
          className={"flex align justify " + (isXsScreen ? "column" : "")}
        >
          {plans.map((plan) => {
            var accept =
              props.decodedToken?.role?.toLowerCase() ===
              plan.name.toLowerCase();
            return (
              <PricingCard key={plan.name}>
                <PricingCardHeader>
                  <Typography variant="h5" gutterBottom>
                    {plan.name}
                  </Typography>
                  <Typography variant="h6">{plan.price}</Typography>
                </PricingCardHeader>

                <PricingCardFeatures
                  style={{ height: "250px", overflow: "auto" }}
                >
                  {Object.entries(plan.features).map(
                    ([featureName, isAvailable]) => (
                      <Feature key={featureName}>
                        <Checkbox checked={isAvailable} disabled />
                        <FeatureText variant="body1">{featureName}</FeatureText>
                      </Feature>
                    )
                  )}
                </PricingCardFeatures>

                <Button
                  variant="contained"
                  href={
                    props.decodedToken
                      ? "/billing/" + plan.name.toLowerCase()
                      : "/signup"
                  }
                  fullWidth
                  disabled={accept}
                  style={{ background: !accept && "rgb(217, 188, 169)" }}
                >
                  {props.decodedToken
                    ? accept
                      ? "Current Plan"
                      : "Choose Plan"
                    : "Sign Up"}
                </Button>
              </PricingCard>
            );
          })}
        </PricingContainer>

        <Typography variant="h4" align="center" style={{ margin: "40px 0" }}>
          Compare Plans
        </Typography>

        <TableContainer component={Paper} style={{ overflow: "hidden" }}>
          <Table stickyHeader style={{ overflow: "hidden" }}>
            <TableHead>
              <TableRow>
                <TableCell></TableCell>
                {isXsScreen ? (
                  <TableCell>
                    <Select
                      value={selectedPlan.name}
                      onChange={(event) =>
                        setSelectedPlan(
                          plans.find((plan) => plan.name === event.target.value)
                        )
                      }
                      style={{ width: "100%" }}
                    >
                      {plans.map((plan) => (
                        <MenuItem value={plan.name} key={plan.name}>
                          {plan.name}
                          <Typography variant="h6">{plan.price}</Typography>
                        </MenuItem>
                      ))}
                    </Select>
                  </TableCell>
                ) : (
                  plans.map((plan) => (
                    <TableCell key={plan.name}>
                      <PricingCard style={{ border: "none" }}>
                        <PricingCardHeader>
                          <Typography variant="h5" gutterBottom>
                            {plan.name}
                          </Typography>
                          <Typography variant="h6">{plan.price}</Typography>
                        </PricingCardHeader>
                      </PricingCard>
                    </TableCell>
                  ))
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {featureNames.map((featureName) => (
                <TableRow key={featureName}>
                  <TableCell style={{ padding: "20px" }}>
                    {featureName}
                  </TableCell>
                  {isXsScreen ? (
                    <TableCell>
                      <Checkbox
                        checked={selectedPlan.features[featureName]}
                        disabled
                      />
                    </TableCell>
                  ) : (
                    plans.map((plan) => (
                      <TableCell key={plan.name}>
                        <Checkbox
                          checked={plan.features[featureName]}
                          disabled
                        />
                      </TableCell>
                    ))
                  )}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <FAQSection />
      </div>
      <footer className="footer">
        <div className="container">
          <p className="footer-text">
            &copy; 2023 Timely. All rights reserved.
          </p>
        </div>
      </footer>
    </>
  );
};

export default PricingPage;
